import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={61.54}
      height={72.704}
      viewBox="0 0 61.54 72.704"
      {...props}
    >
      <g data-name="Group 425">
        <path
          data-name="Path 7429"
          d="M30.338 22.996a8.171 8.171 0 0012.165-8.425L41.045 4.394l-8.8 3.538z"
          fill="#a0d468"
        />
        <path
          data-name="Path 7430"
          d="M15.872 19.174a9.763 9.763 0 1011.939-13.99L16.445.57l-1.743 12.123a9.681 9.681 0 001.17 6.481z"
          fill="#609c20"
        />
        <path
          data-name="Path 7431"
          d="M43.076 14.545c0-.017 0-.035-.005-.052l-1.463-10.18a.57.57 0 00-.777-.448l-6.73 2.707a.57.57 0 10.425 1.058l6.059-2.436 1.35 9.393a.572.572 0 00.008.08 7.606 7.606 0 01-11.318 7.835l-.037-.019a10.329 10.329 0 001.066-.932l6.672-1.785a.57.57 0 00-.3-1.1l-5.135 1.376a10.325 10.325 0 001.31-2.76l4.582-1.228a.57.57 0 00-.3-1.1l-3.371.9 1.268-2.2 2.679-.718a.57.57 0 00-.3-1.1l-1.578.423 1.22-2.093a.57.57 0 00-.987-.57l-1.213 2.1-.423-1.578a.57.57 0 10-1.1.3l.718 2.679-.742 1.285a10.3 10.3 0 00-6.62-9.715h-.011l-2.58-1.047a.57.57 0 00-.429 1.057l2.556 1.037.035.015a9.166 9.166 0 011.786 16.213l-.957-1.657 2.074-7.741a.57.57 0 10-1.1-.3l-1.779 6.64-2.108-3.664 1.439-5.37a.57.57 0 10-1.1-.3l-1.144 4.269-1.665-2.877.867-3.234a.57.57 0 10-1.1-.3l-.573 2.138-1.576-2.73a.57.57 0 10-.987.57l1.576 2.73-2.133-.571a.57.57 0 00-.3 1.1l3.234.867 1.664 2.882-4.264-1.144a.57.57 0 00-.3 1.1l5.37 1.439 2.111 3.656-6.639-1.779a.57.57 0 00-.3 1.1l7.741 2.074.957 1.657a9.159 9.159 0 01-13.13-9.711.553.553 0 00.008-.085l1.624-11.329 3.777 1.533a.57.57 0 00.429-1.057L16.659.042a.57.57 0 00-.779.447l-1.742 12.123a.564.564 0 00-.005.058 10.31 10.31 0 0014.845 10.818l.7 1.214a.57.57 0 10.987-.57l-.26-.45a8.715 8.715 0 004.024.989 8.813 8.813 0 002.271-.3 8.729 8.729 0 006.374-9.826z"
          fill="#fff"
        />
        <path
          data-name="Path 7432"
          d="M23.018 3.809a.57.57 0 10-.4-.167.574.574 0 00.4.167z"
          fill="#fff"
        />
        <path
          data-name="Path 7433"
          d="M38.382 8.51a.57.57 0 00.923-.67.57.57 0 00-.923.67z"
          fill="#fff"
        />
        <g stroke="#fff" strokeWidth={2}>
          <path
            data-name="Path 7427"
            d="M60.54 41.314a3.1 3.1 0 01-3.1 3.1H53.1L30.77 22.708 8.443 44.415H4.1a3.1 3.1 0 01-2.182-5.309L29.48 12.685a1.858 1.858 0 012.58 0L59.6 39.081a3.1 3.1 0 01.943 2.233zm0 0"
            fill="#609c20"
          />
          <path
            data-name="Path 7428"
            d="M30.771 22.708L8.443 44.415V66.74a4.976 4.976 0 004.962 4.962h34.731a4.976 4.976 0 004.962-4.962V44.415zm0 0"
            fill="#b8d98a"
          />
        </g>
        <g data-name="light-bulb (6)" fill="#fff">
          <g data-name="Group 327">
            <path
              data-name="Path 7444"
              d="M27.413 63.654a1.118 1.118 0 001.119 1.119h4.475a1.119 1.119 0 100-2.238h-4.475a1.119 1.119 0 00-1.119 1.119z"
            />
            <path
              data-name="Path 7445"
              d="M27.413 61.417a1.118 1.118 0 001.119 1.119h4.475a1.119 1.119 0 000-2.238h-4.475a1.118 1.118 0 00-1.119 1.119z"
            />
            <path
              data-name="Path 7446"
              d="M34.126 59.179V58.06h-6.713v1.119a1.118 1.118 0 001.119 1.119h4.475a1.119 1.119 0 001.119-1.119z"
            />
          </g>
          <g data-name="Group 328">
            <path
              data-name="Path 7447"
              d="M30.77 67.01a2.238 2.238 0 002.238-2.238h-4.475a2.238 2.238 0 002.237 2.238z"
            />
            <path
              data-name="Path 7448"
              d="M35.245 56.941V55.63a2.224 2.224 0 01.844-1.712 8.391 8.391 0 10-10.6.035 2.23 2.23 0 01.8 1.742v1.246a1.122 1.122 0 001.125 1.119h6.713a1.122 1.122 0 001.118-1.119z"
            />
          </g>
          <g data-name="Group 329">
            <path
              data-name="Path 7449"
              d="M25.142 54.388a1.678 1.678 0 01.594 1.307v1.246a1.678 1.678 0 001.119 1.575v.663a1.671 1.671 0 00.436 1.119 1.652 1.652 0 000 2.238 1.662 1.662 0 00.725 2.708 2.788 2.788 0 005.5 0 1.662 1.662 0 00.733-2.708 1.652 1.652 0 000-2.238 1.671 1.671 0 00.437-1.119v-.662a1.678 1.678 0 001.119-1.575V55.63a1.668 1.668 0 01.639-1.279 8.95 8.95 0 00-5.668-15.869c-.146 0-.293 0-.44.011a9.054 9.054 0 00-8.52 8.883 8.9 8.9 0 003.326 7.012zm8.425 4.791a.56.56 0 01-.559.559h-4.475a.56.56 0 01-.559-.559v-.559h5.593zm0 2.238a.56.56 0 01-.559.559h-4.475a.56.56 0 110-1.119h4.475a.559.559 0 01.559.56zm-2.8 5.034a1.681 1.681 0 01-1.583-1.119h3.169a1.683 1.683 0 01-1.583 1.119zm2.241-2.238h-4.475a.56.56 0 110-1.119h4.475a.56.56 0 010 1.119zm-2.619-24.6a7.829 7.829 0 015.346 13.87 2.78 2.78 0 00-1.049 2.147v1.311a.56.56 0 01-.559.559h-6.711a.56.56 0 01-.559-.559v-1.247a2.775 2.775 0 00-1.007-2.178 7.784 7.784 0 01-2.909-6.132 7.92 7.92 0 017.448-7.774z"
            />
            <path
              data-name="Path 7450"
              d="M30.77 34.007a.56.56 0 01.559.556v2.241a.56.56 0 01-1.119 0v-2.241a.559.559 0 01.56-.556z"
            />
            <path
              data-name="Path 7451"
              d="M37.203 35.731a.559.559 0 01.484.839l-1.119 1.937a.56.56 0 01-.973-.553v-.006l1.123-1.937a.558.558 0 01.485-.28z"
            />
            <path
              data-name="Path 7452"
              d="M41.911 40.44a.559.559 0 01.279 1.039l-1.937 1.123a.56.56 0 01-.566-.965h.007l1.937-1.123a.554.554 0 01.28-.074z"
            />
            <path
              data-name="Path 7453"
              d="M41.395 46.872h2.241a.56.56 0 110 1.119h-2.241a.56.56 0 110-1.119z"
            />
            <path
              data-name="Path 7454"
              d="M39.975 52.186a.558.558 0 01.28.075l1.937 1.119a.56.56 0 11-.553.973h-.006l-1.937-1.127a.559.559 0 01.279-1.04z"
            />
            <path
              data-name="Path 7455"
              d="M21.565 52.187a.559.559 0 01.279 1.039l-1.937 1.123a.56.56 0 11-.566-.965h.006l1.938-1.122a.558.558 0 01.28-.075z"
            />
            <path
              data-name="Path 7456"
              d="M17.901 46.872h2.241a.56.56 0 110 1.119h-2.241a.56.56 0 010-1.119z"
            />
            <path
              data-name="Path 7457"
              d="M19.629 40.439a.558.558 0 01.28.075l1.937 1.119a.56.56 0 11-.553.973h-.007l-1.937-1.127a.559.559 0 01.28-1.04z"
            />
            <path
              data-name="Path 7458"
              d="M24.337 35.731a.559.559 0 01.485.28l1.119 1.937a.56.56 0 11-.965.565v-.007l-1.123-1.936a.559.559 0 01.484-.839z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default SvgComponent
